/* build 2026-09-23b free-box guard + free-box variants + fixed-price plan totals + sub-only + qty-threshold tiers + 8 explicit slots */
$(function() {
  if($('.product-purchase-form').length) {
    var button = $('.quantity-submit-row');
    $(window).scroll(function() {
      if ($(window).width() < 769) {
        var scroll = $(window).scrollTop();
    
        if (scroll >= $('.product-purchase-form').offset().top) { 
          button.addClass('stick');
        } else { 
          button.removeClass('stick');
        }
      }
    });
  }
});

$(document).ready(function() {
  
  /* custom mega menu */
  $(".with-products .navigation__link").on("mouseover", function () {
    $(".with-products .navigation__link").removeClass('active');
    $(this).addClass('active');
  
    var title = $(this).attr('data-menu-title');
    $(".menu_products").removeClass('active');
    $('.menu_products[data-menu="'+title+'"]').addClass('active');
  });
  /* custom mega menu */


  /* custom nutrition images */
  $('.nutrition-thumbs li button').on("click", function (e) {
    e.preventDefault();
    $(".nutrition-thumbs li button").removeClass('active');
    $(this).addClass('active');
    
    var image = $(this).attr('data-index');
    $('.nutrition-slideshow').slick('slickGoTo', image - 1);
  });
  /* custom nutrition images */

  if($('.faq-index__sticky-container').length) {
    setTimeout(function() { 
      $('#content .container .section-faq-header--with-index .faq-header .faq-index .faq-index__sticky-container .faq-index__item-container .faq-index-item:first .faq-index-item__link').addClass('active');
      $('#content .container .section-collapsible-tabs:first .cc-accordion').addClass('active');
    }, 1000);
  }

  /* bundle pages */
  if($('.custom-bundle-wrap').length) {
    var ctr = 0;
    var limit = parseInt($('.custom-bundle-wrap').attr('data-limit'));

    if($('.section-featured-product-bundle').length) {
      $('.opt-btn').on('change', function() {
        ctr = 0;
        limit = parseInt($(this).attr('data-count'));
        $('.custom-bundle-wrap').attr('data-limit', limit);

        $('.product-chosen-item').removeClass('hidden');
        $('.product-chosen-item').each(function(e){
          if(parseInt($(this).attr('data-index')) > limit) {
            $(this).addClass('hidden');
          }
        });

        $('.product-purchase-form .flavors').each(function(e){
          $(this).val("");
        });

        $('.product-chosen .product-chosen-item').each(function(e){ 
          $(this).addClass('empty-item');
          $(this).children('.not-empty').hide();
        });

        $('.quantity-wrapper input[name="quantity"]').val(1);
        $('.quantity-wrapper').hide();
        $('.btn_add_to_cart').show();

        $('.btn_add_to_cart:not(.btn-sold-out)').prop('disabled', false);
        $('.btn-add-all').prop('disabled', true);
        if (limit == 1) {
          $('#add_text').text("Pick "+limit+" More Box");
        } else {
          $('#add_text').text("Pick "+limit+" More Boxes");
        }
        
        
      });
    }

    $('.btn-add-all').prop('disabled', true);
    if($('.section-featured-product-bundle').length) {
      $('.btn-add-all').html('<span id="add_text">Pick <span id="add_ctr">'+limit+'</span> More Boxes</span>');
    } else {
      $('.btn-add-all').html('<span id="add_text">Pick <span id="add_ctr">'+limit+'</span> More Bags</span>');
    }
    

    $('body').on('click', '.btn_add_to_cart', function(){
      $(this).hide();
      $(this).next().show();
      ctr = ctr + 1;

      const img = $(this).attr('data-img');
      const prod_id = $(this).attr('data-id');
      const flavor = $(this).attr('data-flavor');

      $('.product-purchase-form .flavors').each(function(e){
        if($(this).val() == '') {
          $(this).val(flavor);
          return false;
        }
      });

      addToCartText(ctr,limit);
      replaceImage(img, prod_id, flavor);

    });


    $('body').on('click', '.remove-product', function(e){
      e.preventDefault();

      const prod_id = $(this).parent().attr('data-product');
      const index = $(this).parent().attr('data-index');
      const flavor = $(this).parent().attr('data-flavor');

      const elem = $('.btn_add_to_cart[data-id="'+prod_id+'"]').next().children('input');
      const qty_now = parseInt(elem.val());
      if (qty_now == 1) {
        elem.parent().hide();
        elem.parent().prev().show();
      } else {
        elem.val(qty_now-1);
      }
      ctr = ctr - 1;
      addToCartText(ctr,limit);

      $('.product-purchase-form .flavors').each(function(e){
        if($(this).val() == flavor) {
          $(this).val("");
          return false;
        }
      });

      const prod_item = $(this).parent();
      prod_item.children('.not-empty').attr("src", "");
      prod_item.children('.not-empty').hide();
      prod_item.addClass('empty-item');
      prod_item.children('.empty').show();
    });

    
    $('body').on('click', '.minus', function(){
      const qty = parseInt($(this).next().val());
      const new_qty = qty - 1;
      if (new_qty < 1) {
        $(this).parent().hide();
        $(this).parent().prev().show();
        ctr = ctr - 1;
        addToCartText(ctr,limit);
      } else {
        $(this).next().val(new_qty);
        ctr = ctr - 1;
        addToCartText(ctr,limit);
      }

      const flavor = $(this).parent().prev().attr('data-flavor');
      $('.product-purchase-form .flavors').each(function(e){
        if($(this).val() == flavor) {
          $(this).val("");
          return false;
        }
      });
      
      const prod_id = $(this).parent().prev().attr('data-id');
      $('.product-chosen .product-chosen-item').each(function(e){
        if($(this).attr('data-product') == prod_id && $(this).hasClass('empty-item') == false) {
          $(this).children('.not-empty').attr("src", "");
          $(this).children('.not-empty').hide();
          $(this).addClass('empty-item');
          $(this).children('.empty').show();
    
          return false;
        }
      });
    });

    
    $('body').on('click', '.plus', function(){
      const qty = parseInt($(this).prev().val());
      const new_qty = qty + 1;
      if (new_qty <= limit) {
        $(this).prev().val(new_qty);
        ctr = ctr + 1;
        addToCartText(ctr,limit);

        const img = $(this).parent().prev().attr('data-img');
        const prod_id = $(this).parent().prev().attr('data-id');
        const flavor = $(this).parent().prev().attr('data-flavor');
        replaceImage(img, prod_id, flavor);

        $('.product-purchase-form .flavors').each(function(e){
          if($(this).val() == '') {
            $(this).val(flavor);
            return false;
          }
        });
      }
    });
  }
  /* bundle pages */

  
});

// if ($('body').hasClass('template-suffix-variety-pack-product')) {
//   $(document).scroll(function () {
//       var y = $(this).scrollTop();
//     console.log('y', y);
//       if (y > 100) {
//         $('#shopify-section-announcement-bar').fadeOut();
//         $('#shopify-section-header .pageheader').fadeOut();
//       } else {
//         $('#shopify-section-announcement-bar').fadeIn();
//         $('#shopify-section-header .pageheader').fadeIn();
//       }
//   });
// }

function replaceImage(image, id, product) {
  $('.product-chosen .product-chosen-item').each(function(e){ 
    if($(this).hasClass('empty-item')) {
      $(this).attr('data-product', id);
      $(this).attr('data-flavor', product);
      $(this).children('.not-empty').show();
      $(this).children('.not-empty').attr("src", image);
      $(this).removeClass('empty-item');
      $(this).children('.empty').hide();

      return false;
    }
  });
}

function addToCartText(counter, maximum) {
  if (counter == maximum) {
    $('.btn_add_to_cart:not(.btn-sold-out)').prop('disabled', true);
    $('#add_text').text("Add to Cart");
    $('.btn-add-all').removeAttr('disabled');

    $('button.plus').prop('disabled', true);
  } else {
    $('.btn_add_to_cart:not(.btn-sold-out)').prop('disabled', false);
    $('.btn-add-all').prop('disabled', true);

    $('button.plus').prop('disabled', false);
    
    if(maximum-counter == 1) {
      if($('.section-featured-product-bundle').length) {
        $('#add_text').text("Pick 1 More Box");
      } else {
        $('#add_text').text("Pick 1 More Bag");
      }
    } else {
      if($('.section-featured-product-bundle').length) {
        $('#add_text').text("Pick "+(maximum-counter)+" More Boxes");
      } else {
        $('#add_text').text("Pick "+(maximum-counter)+" More Bags");
      }
    }
  }
}

/* Shared Loop selling-plan resolution, used by the bundle builder and the
   product-page subscription block. */
window.NutsolaLoop = window.NutsolaLoop || (function () {
  /**
   * Parse a manual override textarea: "30:10=1256030313" per line,
   * frequency:discount=planId. Returns a { "freq:pct": planId } map.
   */
  function parsePlanMap(raw) {
    var out = {};
    (raw || '').split('\n').forEach(function (line) {
      var m = line.trim().match(/^(\d+)\s*:\s*([\d.]+)\s*=\s*(\d+)$/);
      if (m) out[m[1] + ':' + parseFloat(m[2])] = parseInt(m[3], 10);
    });
    return out;
  }

  /**
   * Whether a plan delivers on the given interval. Liquid can't expose the
   * delivery interval, so it is recovered from the plan's option value and
   * name (e.g. "Deliver every 30 days").
   *
   * The interval is matched against WHOLE numbers pulled out of those strings,
   * not by substring: a substring test would match freq 30 against a plan named
   * "Deliver every 300 days" and silently subscribe the customer to the wrong
   * cadence.
   */
  function matchesFrequency(plan, freq) {
    var hay = String(plan.label || '') + ' ' + String(plan.name || '');
    // Strip percentage figures before pulling out candidate numbers. A plan
    // named "Save 30% every 60 days" would otherwise let the "30" in "30%"
    // be misread as a 30-day frequency and match the wrong cadence.
    hay = hay.replace(/\d+\s*%/g, '');
    var numbers = hay.match(/\d+/g) || [];
    return numbers.indexOf(String(freq)) !== -1;
  }

  /**
   * Loop selling plan for a given frequency and discount percentage.
   *
   *   plans    - array of { id, pct, label, name } from the data-plans attribute
   *   override - map from parsePlanMap
   * Returns a plan id, or null when nothing matches.
   */
  function resolvePlan(plans, override, pct, freq) {
    var manual = override[freq + ':' + pct];
    if (manual) return manual;

    for (var i = 0; i < plans.length; i++) {
      var p = plans[i];
      if (!matchesFrequency(p, freq)) continue;
      if (Math.abs(parseFloat(p.pct) - pct) < 0.01) return parseInt(p.id, 10);
    }
    return null;
  }

  /** Safely read a data-plans attribute. Returns [] on anything malformed. */
  function readPlans(raw) {
    try { return JSON.parse(raw || '[]'); } catch (e) { return []; }
  }

  return {
    parsePlanMap: parsePlanMap,
    resolvePlan: resolvePlan,
    readPlans: readPlans,
    matchesFrequency: matchesFrequency
  };
})();

/* Bundle builder (Featured product > Bundle builder block) */
(function () {
  function initBundleBuilder(root) {
    var minTotal    = parseInt(root.dataset.minTotal, 10)    || 0;
    var maxTotal    = parseInt(root.dataset.maxTotal, 10)    || 0;
    var stepTotal   = parseInt(root.dataset.stepTotal, 10)   || 1;
    var barsPerUnit = parseInt(root.dataset.barsPerUnit, 10) || 1;
    var freeEveryN  = parseInt(root.dataset.freeEveryN, 10)  || 0;
    var moneyFormat = root.dataset.moneyFormat || '$';
    if (stepTotal < 1) stepTotal = 1;
    if (barsPerUnit < 1) barsPerUnit = 1;
    if (freeEveryN < 0) freeEveryN = 0;

    function formatMoney(cents) {
      if (window.theme && theme.Shopify && typeof theme.Shopify.formatMoney === 'function') {
        try { return theme.Shopify.formatMoney(cents, moneyFormat); } catch (e) {}
      }
      return '$' + (Math.round(cents) / 100).toFixed(2);
    }

    var progressEl = root.querySelector('[data-bundle-progress]');
    var ctaEl      = root.querySelector('[data-bundle-cta]');
    var errorEl    = root.querySelector('[data-bundle-error]');
    var rows       = root.querySelectorAll('[data-bundle-row]');

    // Optional sticky order bar. It owns no cart logic — syncStickyBar() copies
    // the real CTA's label and disabled state, and a click is forwarded to it,
    // so there is still exactly one add-to-cart path.
    var stickyEl     = root.querySelector('[data-bundle-sticky]');
    var stickyCtaEl  = stickyEl && stickyEl.querySelector('[data-bundle-sticky-cta]');
    var stickyMetaEl = stickyEl && stickyEl.querySelector('[data-bundle-sticky-meta]');

    function syncStickyBar() {
      if (!stickyCtaEl) return;
      stickyCtaEl.innerHTML = ctaEl.innerHTML;
      stickyCtaEl.disabled = ctaEl.disabled;
      stickyCtaEl.classList.toggle('is-ready', ctaEl.classList.contains('is-ready'));
      stickyCtaEl.classList.toggle('is-loading', ctaEl.classList.contains('is-loading'));
      if (stickyMetaEl) stickyMetaEl.textContent = progressEl.textContent.trim();
    }

    if (stickyCtaEl) {
      stickyCtaEl.addEventListener('click', function () {
        if (stickyCtaEl.disabled) return;
        ctaEl.click();
        syncStickyBar();
      });

      // Reveal the bar only once the real button has scrolled out of view
      // upwards. rootMargin's bottom inset keeps it hidden while the builder is
      // still below the fold, so it never covers content the user hasn't
      // reached yet.
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            stickyEl.hidden = !scrolledPast;
          });
        }, { threshold: 0 }).observe(ctaEl);
      }
    }

    // Optional visual tier bar (percentage discounts). Purely presentational —
    // actual discounts are applied by Shopify automatic discounts. Lights up
    // one step per bag added; the last step stays active for "3+".
    // One tier bar per purchase type. Without the subscription layer there is
    // only the "onetime" bar and behaviour is unchanged.
    var subEnabled = root.dataset.subEnable === '1';

    function readTier(name) {
      var el = root.querySelector('[data-bundle-tier="' + name + '"]');
      if (!el) return null;
      var steps = el.querySelectorAll('.step');
      return {
        el: el,
        steps: steps,
        fill: el.querySelector('.bundle-progress-bar-active'),
        // Percentage discount attached to each step (e.g. 0, 10, 15). The last
        // step's percentage applies to any total at or beyond it ("3+").
        // data-pct is derived in Liquid from free-text marketing copy
        // ("15% OFF" -> 15); a merchant edit that drops the numeric prefix
        // (e.g. "Save 15%") yields a non-numeric value. Do NOT fall back to 0
        // here — that would silently resolve a 0%-discount plan. Leave NaN as
        // NaN so currentTierPct() below can propagate it as a hard failure.
        pcts: Array.prototype.map.call(steps, function (s) {
          return parseFloat(s.getAttribute('data-pct'));
        }),
        // Unit count each step applies from (data-qty, derived from the label's
        // leading number). Lets a granola-style ladder run 4 / 8 / 12 bags with
        // three steps instead of twelve. Falls back to the 1-based index, which
        // reproduces the original "one step per unit" behaviour exactly.
        qtys: Array.prototype.map.call(steps, function (s, i) {
          var q = parseInt(s.getAttribute('data-qty'), 10);
          return isFinite(q) && q > 0 ? q : i + 1;
        })
      };
    }

    // Index of the tier step reached at `total` units: the last step whose
    // threshold is <= total. -1 when no step is reached yet.
    function tierIndexAt(tier, total) {
      if (!tier || !tier.qtys || !tier.qtys.length) return Math.min(total, tier && tier.pcts ? tier.pcts.length : 0) - 1;
      var idx = -1;
      for (var i = 0; i < tier.qtys.length; i++) {
        if (tier.qtys[i] <= total) idx = i;
      }
      return idx;
    }

    var tiers = { onetime: readTier('onetime'), subscription: readTier('subscription') };

    // Subscription-only / buy-X-get-Y pages carry no subscription tier bar:
    // the free product is priced into the Loop plan itself, so the discount
    // used for plan lookup is a fixed figure from the block (sub_plan_pct).
    // Synthesize a one-step tier from it so subscription stays selectable and
    // resolvePlan() gets a numeric pct (e.g. 0 -> map key "30:0").
    var subPlanPct = parseFloat(root.dataset.subPlanPct);
    if (subEnabled && !tiers.subscription && isFinite(subPlanPct)) {
      tiers.subscription = { el: null, steps: [], fill: null, pcts: [subPlanPct] };
    }

    // Subscriptions depend on selling plans published by the subscription app.
    // Until those exist, every row's data-plans is an empty array and the first
    // Add to cart bounces with "temporarily unavailable" — which reads as a
    // broken page rather than a setup step. Flag it up front so the state is
    // visible before the customer commits to a click. This resolves to false the
    // moment real plans are attached, so it costs nothing in production.
    if (subEnabled) {
      var anyPlans = Array.prototype.some.call(rows, function (row) {
        try { return JSON.parse(row.dataset.plans || '[]').length > 0; }
        catch (e) { return false; }
      });
      root.classList.toggle('bundle-builder--no-plans', !anyPlans);
    }

    var purchaseType = subEnabled ? (root.dataset.subDefaultType || 'subscription') : 'onetime';
    if (!tiers[purchaseType]) {
      purchaseType = 'onetime';
      // Liquid may already have rendered the subscription radio as checked
      // and added is-subscription to the root (sub_enable on, tier_enable
      // off — there's no subscription tier bar to back a discount). Sync the
      // DOM so the UI can never claim "subscription" while the cart gets a
      // one-time order.
      root.classList.remove('is-subscription');
      var fallbackOtRadio = root.querySelector('[data-purchase-type][value="onetime"]');
      if (fallbackOtRadio) fallbackOtRadio.checked = true;
    }

    var frequency = parseInt(root.dataset.subDefaultFrequency, 10) || 30;

    function getPurchaseType() { return purchaseType; }
    function getFrequency() { return frequency; }

    function activeTier() { return tiers[purchaseType] || tiers.onetime; }

    function activeTierPcts() {
      var t = activeTier();
      return t ? t.pcts : [];
    }

    // Percentage for a given bag count under the active purchase type.
    // The last step applies to everything at or beyond it ("3+").
    // May return NaN (a non-finite result) when the underlying data-pct is
    // non-numeric; callers must treat that as a hard failure for
    // subscription rather than coercing it to 0 (see readTier above).
    function currentTierPct(total) {
      var tier = activeTier();
      var pcts = activeTierPcts();
      if (!pcts.length || total <= 0) return 0;
      var idx = tierIndexAt(tier, total);
      if (idx < 0) return 0;
      return pcts[idx];
    }

    // Discount (in cents) implied by the active tier for a given bag count.
    // Presentational — mirrors the Shopify automatic discount so the CTA shows
    // the price the customer will actually pay at checkout.
    function tierDiscountCents(total, totalCents) {
      var pct = currentTierPct(total);
      if (!pct) return 0;
      return Math.round(totalCents * pct / 100);
    }

    /**
     * Exact subscription total when every selected row resolves to a Loop
     * plan priced as a fixed PRICE per unit (Loop "Set price"). The CTA then
     * shows what the cart will really charge (3 x $37.33 = $111.99) instead of
     * the list-minus-free arithmetic, which lands a cent off after Loop's
     * per-unit rounding. Returns null for one-time, for percentage plans, or
     * when any row lacks such a plan, and callers keep the existing math.
     */
    function planTotalCents(total) {
      if (purchaseType !== 'subscription' || total <= 0) return null;
      var pct = currentTierPct(total);
      var cents = 0, any = false;
      for (var i = 0; i < rows.length; i++) {
        var q = parseInt(rows[i].dataset.qty || '0', 10) || 0;
        if (!q) continue;
        var plans = window.NutsolaLoop.readPlans(rows[i].dataset.plans);
        var id = window.NutsolaLoop.resolvePlan(plans, planOverride, pct, frequency);
        var plan = null;
        for (var j = 0; j < plans.length; j++) {
          if (parseInt(plans[j].id, 10) === id) { plan = plans[j]; break; }
        }
        if (!plan || plan.type !== 'price' || !(parseInt(plan.price, 10) > 0)) return null;
        cents += q * parseInt(plan.price, 10);
        any = true;
      }
      if (any && hasFreeMap && freeEveryN > 0) {
        // The free boxes ride along at $0, so only the paid units are charged.
        var parts = splitFree(total);
        cents = 0;
        for (var k = 0; k < parts.length; k++) {
          var pl = window.NutsolaLoop.readPlans(parts[k].row.dataset.plans);
          var pid = window.NutsolaLoop.resolvePlan(pl, planOverride, pct, frequency);
          for (var m = 0; m < pl.length; m++) {
            if (parseInt(pl[m].id, 10) === pid) { cents += parts[k].paid * parseInt(pl[m].price, 10); break; }
          }
        }
      }
      return any ? cents : null;
    }

    /** Unit price of the first row's fixed-PRICE plan, for the preview label. */
    function planUnitCents() {
      if (purchaseType !== 'subscription') return 0;
      var pct = currentTierPct(minTotal || 1);
      for (var i = 0; i < rows.length; i++) {
        var plans = window.NutsolaLoop.readPlans(rows[i].dataset.plans);
        var id = window.NutsolaLoop.resolvePlan(plans, planOverride, pct, frequency);
        for (var j = 0; j < plans.length; j++) {
          if (parseInt(plans[j].id, 10) === id && plans[j].type === 'price' && parseInt(plans[j].price, 10) > 0) {
            return parseInt(plans[j].price, 10);
          }
        }
      }
      return 0;
    }

    // Struck-through full price, shown only when a discount actually applies.
    function strikeSpan(str) {
      return '<span style="text-decoration:line-through;text-decoration-thickness:2px;opacity:0.7;font-weight:500;margin-right:6px;">' + str + '</span>';
    }

    /**
     * Per-bag price shown on each purchase option, so the customer can compare
     * Autoship against One-time at the bag count they've actually chosen.
     * Below the minimum we preview the price at 1 bag rather than showing
     * nothing. Struck-through full price appears only when a discount applies.
     */
    function updatePurchasePrices(total) {
      var priceEls = root.querySelectorAll('[data-purchase-price]');
      if (!priceEls.length) return;

      var unit = 0;
      for (var i = 0; i < rows.length; i++) {
        var p = parseInt(rows[i].dataset.price || '0', 10) || 0;
        if (p > 0) { unit = p; break; }
      }
      if (!unit) return;

      var shown = total > 0 ? total : 1;

      priceEls.forEach(function (el) {
        var tier = tiers[el.getAttribute('data-purchase-price')];
        if (!tier || !tier.pcts.length) { el.innerHTML = ''; return; }

        var shownIdx = tierIndexAt(tier, shown);
        var pct = shownIdx < 0 ? 0 : tier.pcts[shownIdx];
        // data-pct comes from merchant copy and can be non-numeric; treat that
        // as "no discount" for display only — resolution still blocks the add.
        if (!isFinite(pct)) pct = 0;

        var net = Math.round(unit * (100 - pct) / 100);
        el.innerHTML = (pct > 0 ? strikeSpan(formatMoney(unit)) : '') +
                       formatMoney(net) + '<span>/bag</span>';
      });
    }

    function paintTier(tier, total) {
      if (!tier || !tier.steps.length) return;
      var stepCount = tier.steps.length;
      var activeCount = tierIndexAt(tier, total) + 1;
      tier.steps.forEach(function (step, i) {
        var lbl = step.querySelector('.step-label');
        if (lbl) lbl.classList.toggle('active', i < activeCount);
      });
      var denom = stepCount > 1 ? stepCount - 1 : 1;
      var reached = Math.max(0, activeCount - 1);
      if (tier.fill) tier.fill.style.width = ((reached / denom) * 68) + '%';
    }

    // Paint both bars so the hidden one is already correct when toggled.
    function updateTier(total) {
      paintTier(tiers.onetime, total);
      paintTier(tiers.subscription, total);
    }

    var tplIncomplete   = root.dataset.progressIncomplete   || '';
    var tplFreeUnlocked = root.dataset.progressFreeUnlocked || '';
    var tplReady        = root.dataset.progressReady        || '';
    var ctaLabel        = root.dataset.ctaReady             || '';

    function fill(tpl, vars) {
      return (tpl || '').replace(/\[(added_bars|target_bars|remaining_bars_total|remaining_bars|free_bars_at_target|free_bars|min_bars|max_bars|bars_per_unit|per_bar|total_full_strike|total_full|total_cents|total|min_total|max_total|discount_cents|discount|free_count|paid_count|added|target|remaining|step)\]/g, function (_, key) {
        return vars[key] != null ? vars[key] : '';
      });
    }

    var planOverride = window.NutsolaLoop.parsePlanMap(root.dataset.subPlanMap);

    // Buy-X-get-1 subscriptions: paid variant id -> $0 "free box" variant id.
    // With this map, every Nth box (free_every_n) goes into the cart as the
    // free variant on the same Loop plan, so the customer sees 2 x $56 + FREE
    // and the subscription renews exactly like that. Without it, the free box
    // has to be priced into the plan (see planTotalCents).
    var freeVariantMap = {};
    (root.dataset.subFreeMap || '').split(/[\n,]+/).forEach(function (pair) {
      var m = pair.trim().match(/^(\d+)\s*=\s*(\d+)$/);
      if (m) freeVariantMap[m[1]] = parseInt(m[2], 10);
    });
    var hasFreeMap = Object.keys(freeVariantMap).length > 0;

    // Split the chosen rows into paid and free units. The free units are taken
    // from the LAST rows the customer filled (they all cost the same here), one
    // per free_every_n units overall. Returns [{ row, paid, free }].
    function splitFree(total) {
      var freeLeft = (hasFreeMap && freeEveryN > 0) ? Math.floor(total / freeEveryN) : 0;
      var out = [];
      for (var i = rows.length - 1; i >= 0; i--) {
        var q = parseInt(rows[i].dataset.qty || '0', 10) || 0;
        if (!q) continue;
        var free = Math.min(q, freeLeft);
        freeLeft -= free;
        out.unshift({ row: rows[i], paid: q - free, free: free });
      }
      return out;
    }

    function resolvePlanForRow(row, pct, freq) {
      return window.NutsolaLoop.resolvePlan(
        window.NutsolaLoop.readPlans(row.dataset.plans), planOverride, pct, freq
      );
    }

    function revertToOneTime(message) {
      purchaseType = 'onetime';
      root.classList.remove('is-subscription');
      var otRadio = root.querySelector('[data-purchase-type][value="onetime"]');
      if (otRadio) otRadio.checked = true;
      errorEl.textContent = message;
      errorEl.style.display = '';
      update();
    }

    function getTotal() {
      var total = 0;
      rows.forEach(function (row) {
        var q = parseInt(row.dataset.qty || '0', 10) || 0;
        total += q;
      });
      return total;
    }

    function getTotalCents() {
      var cents = 0;
      rows.forEach(function (row) {
        var q = parseInt(row.dataset.qty || '0', 10) || 0;
        var p = parseInt(row.dataset.price || '0', 10) || 0;
        cents += q * p;
      });
      return cents;
    }

    /**
     * Buy N-1, get 1 free: every Nth item in the cart is free, choosing
     * the cheapest items as the free ones.
     * Returns { freeCount, paidCount, discountCents }.
     */
    function getDiscount(total) {
      if (freeEveryN <= 0 || total <= 0) {
        return { freeCount: 0, paidCount: total, discountCents: 0 };
      }
      var freeCount = Math.floor(total / freeEveryN);
      if (freeCount <= 0) {
        return { freeCount: 0, paidCount: total, discountCents: 0 };
      }
      var prices = [];
      rows.forEach(function (row) {
        var q = parseInt(row.dataset.qty || '0', 10) || 0;
        var p = parseInt(row.dataset.price || '0', 10) || 0;
        for (var i = 0; i < q; i++) prices.push(p);
      });
      prices.sort(function (a, b) { return a - b; });
      var discountCents = 0;
      for (var j = 0; j < freeCount && j < prices.length; j++) {
        discountCents += prices[j];
      }
      return {
        freeCount: freeCount,
        paidCount: total - freeCount,
        discountCents: discountCents
      };
    }

    function nextTarget(total) {
      if (total < minTotal) return minTotal;
      if (maxTotal > 0 && total >= maxTotal) return maxTotal;
      var next = Math.ceil((total + 1) / stepTotal) * stepTotal;
      if (next < minTotal) next = minTotal;
      if (maxTotal > 0 && next > maxTotal) next = maxTotal;
      return next;
    }

    function isValidTotal(total) {
      if (total < minTotal) return false;
      if (maxTotal > 0 && total > maxTotal) return false;
      return (total % stepTotal === 0);
    }

    /**
     * Build a vars object simulating "min_total items at the unit price".
     * Used for the CTA label while the bundle is below the minimum,
     * so the customer sees the deal they'd get by completing the bundle.
     */
    function buildPreviewVars() {
      var unitPrice = 0;
      for (var i = 0; i < rows.length; i++) {
        var p = parseInt(rows[i].dataset.price || '0', 10) || 0;
        if (p > 0) { unitPrice = p; break; }
      }
      var simTotal       = minTotal;
      var simTotalCents  = unitPrice * simTotal;
      var simFreeCount   = freeEveryN > 0 ? Math.floor(simTotal / freeEveryN) : 0;
      var simTierDisc    = tierDiscountCents(simTotal, simTotalCents);
      var simDiscountCt  = simFreeCount * unitPrice + simTierDisc;
      var simPayCents    = Math.max(0, simTotalCents - simDiscountCt);
      var simPlanUnit    = planUnitCents();
      if (simPlanUnit) {
        simPayCents   = simPlanUnit * simTotal;
        simDiscountCt = Math.max(0, simTotalCents - simPayCents);
      }
      var simTotalFull   = formatMoney(simTotalCents);
      return {
        added: simTotal,
        target: simTotal,
        remaining: 0,
        step: stepTotal,
        min_total: minTotal,
        max_total: maxTotal,
        added_bars: simTotal * barsPerUnit,
        target_bars: simTotal * barsPerUnit,
        remaining_bars: 0,
        remaining_bars_total: 0,
        free_bars_at_target: simFreeCount * barsPerUnit,
        min_bars: minTotal * barsPerUnit,
        max_bars: maxTotal * barsPerUnit,
        bars_per_unit: barsPerUnit,
        total: formatMoney(simPayCents),
        total_full: simTotalFull,
        total_full_strike: simPayCents < simTotalCents ? strikeSpan(simTotalFull) : '',
        discount: formatMoney(simDiscountCt),
        total_cents: simPayCents,
        discount_cents: simDiscountCt,
        free_bars: simFreeCount * barsPerUnit,
        per_bar: formatMoney(perBarCents(simPayCents, simTotal)),
        free_count: simFreeCount,
        paid_count: simTotal - simFreeCount
      };
    }

    /**
     * Price of one bar at a given box count, floored so the figure never
     * rounds above what the customer actually pays ($112 / 24 bars = $4.66).
     */
    function perBarCents(payCents, boxes) {
      var bars = boxes * barsPerUnit;
      return bars > 0 ? Math.floor(payCents / bars) : 0;
    }

    /**
     * Offer-card figures on the subscription option (sub_price_show): the
     * struck full price, the subscription total, the per-bar line and the
     * savings pill. Fed the live vars once the bundle is at a valid step and
     * the min_total preview below it, so at 3 boxes it reads $168 / $112 and
     * at 6 boxes $336 / $224 — the price moves with the box count, which is
     * what the client asked for on the Figma thread.
     */
    var subCardEls = {
      compare: root.querySelector('[data-bb-sub-compare]'),
      total:   root.querySelector('[data-bb-sub-total]'),
      unit:    root.querySelector('[data-bb-sub-unit]'),
      save:    root.querySelector('[data-bb-sub-save]')
    };
    function wholeMoney(str) {
      // "$112.00" reads as "$112" on the card; cents survive when non-zero.
      return String(str || '').replace(/([.,])00(?=\s*\D*$)/, '');
    }
    function updateSubCard(v) {
      if (!subCardEls.total && !subCardEls.save) return;
      var discounted = v.discount_cents > 0;
      if (subCardEls.compare) {
        subCardEls.compare.textContent = wholeMoney(v.total_full);
        subCardEls.compare.hidden = !discounted;
      }
      if (subCardEls.total) subCardEls.total.textContent = wholeMoney(v.total);
      if (subCardEls.unit) {
        subCardEls.unit.innerHTML = fill(subCardEls.unit.getAttribute('data-tpl') || '', v);
      }
      if (subCardEls.save) {
        // "Save $56", not "Save $56.00" — the pill is a headline, not a receipt.
        var pillVars = Object.assign({}, v, { discount: wholeMoney(v.discount) });
        subCardEls.save.innerHTML = discounted ? fill(subCardEls.save.getAttribute('data-tpl') || '', pillVars) : '';
        subCardEls.save.hidden = !discounted;
      }
    }

    function update() {
      var total = getTotal();
      var target = nextTarget(total);
      var remaining = Math.max(0, target - total);
      var ready = isValidTotal(total) && total > 0;

      var totalCents = getTotalCents();
      var disc = getDiscount(total);
      var tierDisc = tierDiscountCents(total, totalCents);
      var payCents = Math.max(0, totalCents - disc.discountCents - tierDisc);
      var planTotal = planTotalCents(total);
      if (planTotal !== null) {
        payCents = planTotal;
        tierDisc = Math.max(0, totalCents - disc.discountCents - payCents);
      }
      var totalFullStr = formatMoney(totalCents);

      // Paid-only counts (what user actually needs to add — free portion stripped out)
      var freeAtTarget = freeEveryN > 0 ? Math.floor(target / freeEveryN) : 0;
      var paidAtTarget = target - freeAtTarget;
      var paidAtTotal  = total  - disc.freeCount;
      var remainingPaid = Math.max(0, paidAtTarget - paidAtTotal);

      var vars = {
        added: total,
        target: target,
        remaining: remaining,
        step: stepTotal,
        min_total: minTotal,
        max_total: maxTotal,
        added_bars: total * barsPerUnit,
        target_bars: target * barsPerUnit,
        // Bars the customer still has to PAY for to reach the next target
        // (excludes the bars that will be free at that target).
        remaining_bars: remainingPaid * barsPerUnit,
        // Bars-as-pack-count without subtracting free portion (rarely needed)
        remaining_bars_total: remaining * barsPerUnit,
        // How many bars they get for free at the next target
        free_bars_at_target: freeAtTarget * barsPerUnit,
        min_bars: minTotal * barsPerUnit,
        max_bars: maxTotal * barsPerUnit,
        bars_per_unit: barsPerUnit,
        total: formatMoney(payCents),
        total_full: totalFullStr,
        total_full_strike: payCents < totalCents ? strikeSpan(totalFullStr) : '',
        discount: formatMoney(disc.discountCents + tierDisc),
        total_cents: payCents,
        discount_cents: disc.discountCents + tierDisc,
        free_bars: disc.freeCount * barsPerUnit,
        per_bar: formatMoney(perBarCents(payCents, total)),
        free_count: disc.freeCount,
        paid_count: disc.paidCount
      };

      // Three progress states:
      //   ready          → bundle is at a valid step (e.g. 24, 48 bars) — show tplReady
      //   free-unlocked  → paid quota met but bundle below min_total and a free pack is still
      //                    sitting unclaimed (e.g. 16 of 24) — show tplFreeUnlocked if configured
      //   incomplete     → still need to add paid bars — show tplIncomplete
      var freeUnlocked = !ready && total > 0 && remainingPaid === 0 && freeAtTarget > 0 && tplFreeUnlocked;
      var tpl = ready ? tplReady : (freeUnlocked ? tplFreeUnlocked : tplIncomplete);
      progressEl.innerHTML = fill(tpl, vars);
      progressEl.classList.toggle('is-ready', ready);
      progressEl.classList.toggle('is-free-unlocked', !!freeUnlocked);

      updateTier(total);
      updatePurchasePrices(total);

      // CTA label always reflects the deal at min_total (a "preview"),
      // so the disabled button still shows the price the customer will get.
      var ctaVars = ready ? vars : buildPreviewVars();
      updateSubCard(ctaVars);
      ctaEl.innerHTML = fill(ctaLabel, ctaVars);
      ctaEl.disabled = !ready;
      ctaEl.classList.toggle('is-ready', ready);
      syncStickyBar();

      if (maxTotal > 0 && total >= maxTotal) {
        rows.forEach(function (row) {
          var plus = row.querySelector('[data-bundle-plus]');
          if (plus) plus.disabled = true;
        });
      } else {
        rows.forEach(function (row) {
          var plus = row.querySelector('[data-bundle-plus]');
          if (plus) plus.disabled = false;
        });
      }
    }

    function setQty(row, qty) {
      if (qty < 0) qty = 0;
      row.dataset.qty = qty;
      var qtyEl  = row.querySelector('[data-bundle-qty]');
      var addEl  = row.querySelector('[data-bundle-add]');
      var stepEl = row.querySelector('[data-bundle-stepper]');
      if (qtyEl) qtyEl.textContent = qty;
      if (qty > 0) {
        if (addEl)  addEl.style.display  = 'none';
        if (stepEl) stepEl.style.display = '';
      } else {
        if (addEl)  addEl.style.display  = '';
        if (stepEl) stepEl.style.display = 'none';
      }
      update();
    }

    rows.forEach(function (row) {
      row.dataset.qty = '0';
      if (row.dataset.soldOut === '1') return;
      var add   = row.querySelector('[data-bundle-add]');
      var plus  = row.querySelector('[data-bundle-plus]');
      var minus = row.querySelector('[data-bundle-minus]');

      if (add)   add.addEventListener('click', function () { setQty(row, 1); });
      if (plus)  plus.addEventListener('click', function () {
        var total = getTotal();
        if (maxTotal > 0 && total >= maxTotal) return;
        setQty(row, (parseInt(row.dataset.qty, 10) || 0) + 1);
      });
      if (minus) minus.addEventListener('click', function () {
        setQty(row, (parseInt(row.dataset.qty, 10) || 0) - 1);
      });
    });

    if (subEnabled) {
      root.querySelectorAll('[data-purchase-type]').forEach(function (input) {
        input.addEventListener('change', function () {
          if (!input.checked) return;
          purchaseType = input.value === 'subscription' ? 'subscription' : 'onetime';
          root.classList.toggle('is-subscription', purchaseType === 'subscription');
          update();
        });
      });

      var freqEl = root.querySelector('[data-bundle-frequency]');
      if (freqEl) {
        freqEl.addEventListener('change', function () {
          frequency = parseInt(freqEl.value, 10) || frequency;
          update();
        });
      }
    }

    ctaEl.addEventListener('click', function (evt) {
      if (evt && evt.preventDefault) evt.preventDefault();
      if (ctaEl.disabled) return;
      errorEl.style.display = 'none';
      ctaEl.classList.add('is-loading');
      ctaEl.disabled = true;
      syncStickyBar();

      var items = [];
      var wantsSub = subEnabled && getPurchaseType() === 'subscription';
      var pct = currentTierPct(getTotal());
      var freq = getFrequency();
      var unresolved = false;

      var useFree = wantsSub && hasFreeMap && freeEveryN > 0;
      var parts = useFree ? splitFree(getTotal()) : null;

      rows.forEach(function (row, idx) {
        var qty = parseInt(row.dataset.qty, 10) || 0;
        if (qty <= 0) return;
        var vid = parseInt(row.dataset.variantId, 10);
        var planId = null;
        if (wantsSub) {
          planId = resolvePlanForRow(row, pct, freq);
          if (!planId) {
            unresolved = true;
            console.warn('[bundle] no Loop selling plan for ' + pct + '% / ' + freq + ' days on variant ' + vid);
          }
        }
        var paid = qty, free = 0;
        if (useFree) {
          for (var p = 0; p < parts.length; p++) {
            if (parts[p].row === row) { paid = parts[p].paid; free = parts[p].free; break; }
          }
          if (free > 0 && !freeVariantMap[vid]) {
            // No $0 twin for this flavour: keep it paid rather than drop the box.
            paid += free; free = 0;
            console.warn('[bundle] no free-box variant mapped for variant ' + vid);
          }
        }
        if (paid > 0) {
          var item = { id: vid, quantity: paid };
          if (planId) item.selling_plan = planId;
          items.push(item);
        }
        if (free > 0) {
          var freeItem = { id: freeVariantMap[vid], quantity: free };
          if (planId) freeItem.selling_plan = planId;
          items.push(freeItem);
        }
      });

      // Never create a subscription at full price. If any row can't be matched,
      // stop and make the customer choose again rather than silently charging
      // them one-time or subscribing them without the discount.
      if (wantsSub && unresolved) {
        ctaEl.classList.remove('is-loading');
        revertToOneTime('Subscription is temporarily unavailable. Switched to one-time — press Add to cart again to continue.');
        return;
      }

      var addUrl = (window.theme && theme.routes && theme.routes.cart_add_url) || '/cart/add.js';

      fetch(addUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function (res) {
        return res.json().then(function (body) { return { ok: res.ok, body: body }; });
      })
      .then(function (r) {
        if (!r.ok) throw new Error((r.body && r.body.description) || 'Unable to add to cart');

        // Open Rebuy Smart Cart if it's on the page; it auto-refreshes its own contents.
        if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.show === 'function') {
          try { window.Rebuy.SmartCart.show(); } catch (e) {}
        } else {
          // Fallback: native theme drawer (only when Rebuy isn't loaded).
          document.dispatchEvent(new CustomEvent('theme:open-cart-drawer', { bubbles: true, cancelable: false }));
        }

        rows.forEach(function (row) { setQty(row, 0); });
      })
      .catch(function (err) {
        errorEl.textContent = err.message || 'Something went wrong. Please try again.';
        errorEl.style.display = '';
      })
      .finally(function () {
        ctaEl.classList.remove('is-loading');
        update();
      });
    });

    update();
  }

  function boot() {
    document.querySelectorAll('[data-bundle-builder]').forEach(initBundleBuilder);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

/* Product page subscription tiers (Main product > Subscription tiers block) */
(function () {
  function initSubTiers(root) {
    var planInput = root.querySelector('[data-subtiers-plan]');
    var freqEl    = root.querySelector('[data-subtiers-frequency]');
    var noteEl    = root.querySelector('[data-subtiers-note]');
    var qtyEl     = document.querySelector('.product-purchase-form input[name="quantity"]')
                 || document.querySelector('#quantity');

    // Price slot inside the Add to Cart button. It lives outside this widget
    // (in the buy_buttons block) so it is looked up on the document. The
    // theme rewrites only the button's #add_text span on a variant change, so
    // this sibling survives and does not need re-querying.
    var ctaPriceEls = Array.prototype.slice.call(
      document.querySelectorAll('[data-subtiers-cta-price]')
    );

    // The hidden selling_plan input carries a form="..." attribute pointing
    // at the native product form. Use that to find the form's variant id
    // field (a <select name="id"> for multi-option products, populated by
    // the theme's variant picker) so plan lookups can track variant changes.
    var formId       = planInput && planInput.getAttribute('form');
    var productForm  = formId && document.getElementById(formId);
    var variantInput = (productForm && productForm.querySelector('[name="id"]'))
                     || document.querySelector('[name="id"]');

    // "1:10,2:15,3:20" — quantity threshold : discount percentage. The last
    // entry applies to every quantity at or beyond it ("3+").
    var tiers = (root.dataset.tiers || '1:10,2:15,3:20').split(',').map(function (part) {
      var kv = part.split(':');
      return { qty: parseInt(kv[0], 10) || 0, pct: parseFloat(kv[1]) || 0 };
    }).filter(function (t) { return t.qty > 0; })
      .sort(function (a, b) { return a.qty - b.qty; });

    // Shared with the bundle builder — defined once in window.NutsolaLoop.
    var planOverride = window.NutsolaLoop.parsePlanMap(root.dataset.planMap);

    // Plans are rendered per-variant (data-plans is a { variantId: [plan...] }
    // map, not a flat array) because all three protein powder products are
    // multi-variant. Re-reading this map against the currently selected
    // variant id — instead of caching one variant's plans at init — is what
    // keeps the selling_plan valid after the shopper switches variants.
    var plansByVariant = {};
    try { plansByVariant = JSON.parse(root.dataset.plans || '{}'); } catch (e) { plansByVariant = {}; }

    var pricesByVariant = {};
    try { pricesByVariant = JSON.parse(root.dataset.prices || '{}'); } catch (e) { pricesByVariant = {}; }

    // The quantity picker's buttons are keyed by option value ("2 Bags"),
    // the price and plan maps by variant id. These products have a single
    // option, so the variant title is the bridge between them.
    var variantIdByTitle = {};
    Object.keys(pricesByVariant).forEach(function (vid) {
      var t = pricesByVariant[vid].title;
      if (t) variantIdByTitle[t] = vid;
    });

    // The bundle builder keeps its formatMoney private to its own closure, so
    // this block carries a matching one rather than reaching into it.
    var moneyFormat = root.dataset.moneyFormat || '$';
    function formatMoney(cents) {
      if (window.theme && theme.Shopify && typeof theme.Shopify.formatMoney === 'function') {
        try { return theme.Shopify.formatMoney(cents, moneyFormat); } catch (e) {}
      }
      return '$' + (Math.round(cents) / 100).toFixed(2);
    }

    function currentPlans() {
      var vid = variantInput && variantInput.value;
      return (vid && plansByVariant[vid]) || [];
    }

    function currentEntry() {
      var vid = variantInput && variantInput.value;
      return pricesByVariant[vid] || {};
    }

    function currentQty() {
      return parseInt(qtyEl && qtyEl.value, 10) || 1;
    }

    /** Bags in the line: pack size of the chosen variant times the quantity. */
    function currentBags() {
      return (parseInt(currentEntry().units, 10) || 1) * currentQty();
    }

    /**
     * The selling plan for the variant on screen at the chosen frequency.
     *
     * Resolution has to be per-variant. Every bag count here is its own
     * variant carrying its own Loop plans, and the plan ids in the block's
     * plan map belong to the single-bag variant only — handing one of them to
     * the 2-bag variant submits a selling_plan the cart rejects. So a mapped
     * id counts only once it has been found in the selected variant's own
     * allocation list.
     *
     * Order of preference:
     *   1. what the plan map / tier ladder resolves to, when the variant
     *      really carries that plan. This is what holds the single-bag
     *      variant on its 10% plan even though 15% and 20% plans also hang
     *      off it for the landing page's bundle builder.
     *   2. the variant's only plan at this frequency — the normal case for
     *      the multi-bag variants, whose bulk discount is already baked into
     *      the variant price, leaving the plan to add just the remainder.
     */
    function planForVariant(vid, freq) {
      var plans = (vid && plansByVariant[vid]) || [];
      var atFreq = plans.filter(function (p) {
        return window.NutsolaLoop.matchesFrequency(p, freq);
      });
      if (!atFreq.length) return null;

      var units  = parseInt((pricesByVariant[vid] || {}).units, 10) || 1;
      var mapped = window.NutsolaLoop.resolvePlan(
        plans, planOverride, pctFor(units * currentQty()), freq
      );
      if (mapped) {
        for (var i = 0; i < atFreq.length; i++) {
          if (parseInt(atFreq[i].id, 10) === mapped) return atFreq[i];
        }
      }
      return atFreq.length === 1 ? atFreq[0] : null;
    }

    function currentFreq() {
      return parseInt(freqEl && freqEl.value, 10) || 30;
    }

    function currentPlan() {
      return planForVariant(variantInput && variantInput.value, currentFreq());
    }

    /**
     * List price of a whole variant — the figure every saving on this page is
     * measured against, and the one that gets struck through.
     *
     * It is the compare-at price where the merchant set one. The variant price
     * is no use as a baseline on the multi-bag variants: their bulk discount
     * is already inside it, so measuring against it would advertise only the
     * subscription's incremental 5-6% instead of the 15% or 20% off the
     * single-bag rate that the shopper actually gets.
     */
    function listTotal(entry) {
      var price   = parseInt(entry.price, 10) || 0;
      var compare = parseInt(entry.compare, 10) || 0;
      return compare > price ? compare : price;
    }

    /** What a variant costs under the current purchase type, plan included. */
    function netTotal(entry, vid) {
      var price = parseInt(entry.price, 10) || 0;
      if (currentType() !== 'subscription') return price;
      var plan = planForVariant(vid, currentFreq());
      var pct  = plan ? parseFloat(plan.pct) || 0 : 0;
      return Math.round(price * (100 - pct) / 100);
    }

    /**
     * "N% OFF" tabs over the quantity buttons.
     *
     * These used to be baked into variant metafields, which fixed them at the
     * one-time bulk discount (nothing on 1 Bag, 10%, 15%) even while Autoship
     * — the default — was really giving 10%, 15% and 20%. They are now derived
     * from the same list price and plan lookup as everything else, so they
     * follow the Autoship / One-time toggle instead of contradicting it.
     */
    function updateQtyBadges() {
      var labels = document.querySelectorAll('.option-selector__btns .opt-label[data-name]');
      if (!labels.length) return;

      labels.forEach(function (label) {
        var vid = variantIdByTitle[label.getAttribute('data-name')];
        var badge = label.querySelector('.saving');
        if (!vid) return;

        var entry = pricesByVariant[vid] || {};
        var list  = listTotal(entry);
        var pct   = list ? Math.round((1 - netTotal(entry, vid) / list) * 100) : 0;

        if (pct <= 0) {
          // Only ever hide a badge, never delete one: the metafield-driven
          // markup has to survive a switch back to a state that shows it.
          if (badge) badge.style.display = 'none';
          return;
        }

        if (!badge) {
          badge = document.createElement('p');
          badge.className = 'saving no-label';
          badge.appendChild(document.createElement('span'));
          var pack = label.querySelector('.price_pack');
          if (pack) label.insertBefore(badge, pack);
          else label.appendChild(badge);
        }
        badge.style.display = '';
        badge.querySelector('span').textContent = pct + '% OFF';
      });
    }

    /**
     * Per-bag price on each option, so Autoship can be compared against
     * One-time at the pack size on screen. The full price is struck only when
     * a discount actually applies, and only when a plan really resolved —
     * otherwise Autoship would advertise a saving the cart won't honour.
     */
    function updateSubPrices() {
      var entry = currentEntry();
      var vid   = variantInput && variantInput.value;
      // Divide by the pack size so "/bag" is honest on multi-bag variants.
      var units = parseInt(entry.units, 10) || 1;
      var price = parseInt(entry.price, 10) || 0;
      var list  = listTotal(entry);
      var unitLabel = root.dataset.unitLabel || '/bag';

      // The discount comes off the plan that actually resolved, not off the
      // tier ladder: on the multi-bag variants the plan only shaves the
      // remainder off an already-discounted variant, so reading it back off
      // the plan keeps the price shown and the price charged in agreement.
      var plan = currentPlan();
      var pct  = plan ? parseFloat(plan.pct) || 0 : 0;

      var listUnit = Math.round(list / units);
      var priceEls = root.querySelectorAll('[data-subtiers-price]');
      priceEls.forEach(function (el) {
        if (!price) { el.innerHTML = ''; return; }
        var net = el.getAttribute('data-subtiers-price') === 'subscription'
          ? Math.round(price * (100 - pct) / 100 / units)
          : Math.round(price / units);
        var strike = (net < listUnit)
          ? '<span style="text-decoration:line-through;text-decoration-thickness:2px;opacity:0.7;font-weight:500;margin-right:6px;">' +
            formatMoney(listUnit) + '</span>'
          : '';
        el.innerHTML = strike + formatMoney(net) +
                       '<span>' + unitLabel + '</span>';
      });

      updateCtaPrice(list, netTotal(entry, vid));
      updateQtyBadges();
      updateServingPrices();
    }

    /**
     * "$X/serving" under each quantity button.
     *
     * These are merchant-typed metafields, not derived like the badges: the
     * one-time figure is custom.price_per_pack and the Autoship figure is
     * custom.price_per_pack_subscription. Before this they only ever showed the
     * one-time number, so Autoship — the better deal — read as if it cost the
     * same. A variant with no subscription metafield keeps showing its one-time
     * figure rather than going blank.
     */
    function updateServingPrices() {
      var subscribed = currentType() === 'subscription';

      document.querySelectorAll('.price_pack[data-pack-onetime]').forEach(function (el) {
        var oneTime = el.getAttribute('data-pack-onetime') || '';
        var sub     = el.getAttribute('data-pack-sub');
        el.textContent = (subscribed && sub) ? sub : oneTime;
      });
    }

    /**
     * Price inside the Add to Cart button, so what will be charged is on the
     * button being clicked. Line totals here, not the per-bag figures shown
     * on the two options — the button adds the whole line.
     */
    function updateCtaPrice(listTotalCents, netTotalCents) {
      if (!ctaPriceEls.length) return;

      var qty  = currentQty();
      var full = listTotalCents * qty;
      var net  = netTotalCents * qty;

      ctaPriceEls.forEach(function (el) {
        if (!full) {
          el.innerHTML = '';
          el.hidden = true;
          return;
        }
        el.hidden = false;
        el.innerHTML =
          (net < full ? '<s class="btn-add-cart__price-was">' + formatMoney(full) + '</s>' : '') +
          '<span class="btn-add-cart__price-now">' + formatMoney(net) + '</span>';
      });
    }

    /** Headline discount off the single-bag list price for a bag count. */
    function pctFor(bags) {
      var pct = 0;
      for (var i = 0; i < tiers.length; i++) {
        if (bags >= tiers[i].qty) pct = tiers[i].pct;
      }
      return pct;
    }

    function currentType() {
      var checked = root.querySelector('[data-subtiers-type]:checked');
      return checked ? checked.value : 'onetime';
    }

    // Reverts the UI to one-time when no plan resolves for the current
    // quantity/frequency/variant, so the customer never sees "Autoship &
    // Save" selected while the order that goes through is one-time.
    //
    // Sets the one-time radio's .checked property directly rather than
    // dispatching a change event: the change listener below calls update(),
    // and update() is what calls revertToOneTime() in the first place, so
    // dispatching would re-enter update() indefinitely. Setting .checked
    // directly moves the DOM into the one-time state without firing that
    // listener, so this function runs once and settles.
    function revertToOneTime(message) {
      var otRadio = root.querySelector('[data-subtiers-type][value="onetime"]');
      if (otRadio) otRadio.checked = true;
      root.classList.remove('is-subscription');
      planInput.value = '';
      // Leave the note in place so the customer understands why the
      // selection changed, instead of letting the (!isSub) branch below
      // blank it out.
      if (noteEl) noteEl.textContent = message;
    }

    function update() {
      var isSub = currentType() === 'subscription';
      root.classList.toggle('is-subscription', isSub);

      if (!isSub) {
        planInput.value = '';
        if (noteEl) noteEl.textContent = '';
        updateSubPrices();
        return;
      }

      var plan = currentPlan();

      // An unresolved plan must never submit as a plain subscription — revert
      // to one-time so the form doesn't silently charge full price under a
      // subscription label.
      if (!plan) {
        console.warn('[subtiers] no Loop selling plan for variant ' +
                     (variantInput && variantInput.value) + ' at ' +
                     (freqEl && freqEl.value) + ' days');
        revertToOneTime('Subscription is temporarily unavailable for this quantity.');
        updateSubPrices();
        return;
      }

      planInput.value = plan.id;
      // The running "N% off every N days" line that used to sit here has been
      // dropped by request; the saving now reads off the struck prices on the
      // two options and on the Add to Cart button. The note element stays for
      // the unavailable-subscription message above.
      if (noteEl) noteEl.textContent = '';
      updateSubPrices();
    }

    root.querySelectorAll('[data-subtiers-type]').forEach(function (el) {
      el.addEventListener('change', update);
    });
    if (freqEl) freqEl.addEventListener('change', update);
    if (qtyEl) {
      qtyEl.addEventListener('change', update);
      qtyEl.addEventListener('input', update);
      // The theme's +/- buttons set .value directly without firing an event.
      document.querySelectorAll('[data-quantity]').forEach(function (btn) {
        btn.addEventListener('click', function () { setTimeout(update, 0); });
      });
    }
    // Re-read the plan list for the now-selected variant whenever it changes.
    // The theme's variant picker updates this field's value and then fires a
    // real change event on it (see theme.js: `.original-selector.trigger
    // ('change')`), so a plain addEventListener here reliably observes it.
    if (variantInput) variantInput.addEventListener('change', update);

    update();
  }

  function boot() {
    document.querySelectorAll('[data-subtiers]').forEach(initSubTiers);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();


/* Free-box guard (Buy 16 Get 8 Free subscription page).
 * The subscription page adds every 3rd box as a $0 "free box" variant on the
 * same Loop plan. Anything that edits the cart afterwards — the drawer's +/-
 * steppers, /cart/change.js, /cart/update.js — could raise the free quantity
 * on its own. This watches every cart write on the page and, when the free
 * boxes exceed one per PAID_PER_FREE paid boxes on the same selling plan,
 * trims them back (or removes them when there are no paid boxes left), then
 * tells the drawer to redraw. Server-side validation would be the airtight
 * version; this closes the storefront path. */
(function () {
  var FREE_HANDLE   = 'dat-free-box';
  var PAID_PER_FREE = 2;
  var busy = false;

  function isCartWrite(url) {
    return typeof url === 'string' && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url);
  }

  function refreshDrawer() {
    try { document.dispatchEvent(new CustomEvent('theme:cartchanged', { bubbles: true })); } catch (e) {}
    try {
      var R = window.Rebuy;
      if (R && R.Cart) {
        if (typeof R.Cart.reload === 'function') R.Cart.reload();
        else if (typeof R.Cart.refresh === 'function') R.Cart.refresh();
        else if (typeof R.Cart.fetch === 'function') R.Cart.fetch();
      }
    } catch (e) {}
  }

  function enforce() {
    if (busy) return;
    busy = true;
    fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var free = [], paidByPlan = {};
        (cart.items || []).forEach(function (it) {
          var plan = it.selling_plan_allocation && it.selling_plan_allocation.selling_plan && it.selling_plan_allocation.selling_plan.id;
          if (it.handle === FREE_HANDLE) {
            free.push({ key: it.key, qty: it.quantity, plan: plan });
          } else if (plan && it.price > 0) {
            paidByPlan[plan] = (paidByPlan[plan] || 0) + it.quantity;
          }
        });
        if (!free.length) return null;

        // Allowance per plan, handed out to the free lines in cart order.
        var fixes = [];
        var left = {};
        free.forEach(function (f) {
          var planKey = f.plan || 'none';
          if (!(planKey in left)) left[planKey] = f.plan ? Math.floor((paidByPlan[f.plan] || 0) / PAID_PER_FREE) : 0;
          var allowed = Math.min(f.qty, left[planKey]);
          left[planKey] -= allowed;
          if (allowed < f.qty) fixes.push({ id: f.key, quantity: allowed });
        });
        if (!fixes.length) return null;

        return fixes.reduce(function (chain, fix) {
          return chain.then(function () {
            return fetch('/cart/change.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify(fix)
            });
          });
        }, Promise.resolve()).then(function () {
          console.warn('[free-box] trimmed free boxes to the allowance', fixes);
          refreshDrawer();
        });
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  // Watch fetch() writes.
  var origFetch = window.fetch;
  if (typeof origFetch === 'function') {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url);
      var p = origFetch.apply(this, arguments);
      if (!busy && isCartWrite(url)) p.then(function () { setTimeout(enforce, 50); }, function () {});
      return p;
    };
  }

  // Watch XMLHttpRequest writes (jQuery / older cart scripts).
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (!busy && isCartWrite(url)) {
      this.addEventListener('loadend', function () { setTimeout(enforce, 50); });
    }
    return origOpen.apply(this, arguments);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enforce);
  else enforce();
})();

/* Variant gallery covers (Featured product > "Variant gallery covers" block).
   The section renders one cover slide per configured variant
   (data-media-id="variant-cover-<variantId>"); when the theme's product form
   fires variantChanged, jump the gallery to that slide — or back to the first
   real product photo when the chosen variant has no cover. */
(function () {
  if (!window.jQuery) return;
  jQuery(document).on('variantChanged', '.product-form', function (evt, variant) {
    var $section = jQuery(this).closest('.shopify-section');
    if (!$section.find('.slide--variant-cover').length && !($section[0] && $section[0].__coverIds)) return;
    var cover = variant && variant.id ? 'variant-cover-' + variant.id : '';
    var core = window.NutsolaOfferBox;
    if (core && core.showCover) return core.showCover(this, cover);
    // Fallback if offer-boxes.js is missing: plain jump, no filtering.
    var $slideshow = $section.find('.product-slideshow').first();
    if (!$slideshow.length || !$slideshow.hasClass('slick-initialized')) return;
    var $slide = cover ? $slideshow.find('.slide[data-media-id="' + cover + '"]').first() : jQuery();
    if (!$slide.length) $slide = $slideshow.find('.slide:not(.slide--offer-cover)').first();
    var index = parseInt($slide.attr('data-slick-index'), 10);
    if (!isNaN(index)) $slideshow.slick('slickGoTo', index);
  });
})();
